import { render } from "./PageFooter.vue?vue&type=template&id=02522b79"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__